<app-menu [hasChanges]="loadMenu" title="Registre sus cotizaciones"></app-menu>
<app-loading [show]="load"></app-loading>
<div class="m-2">
    <div class="mb-3">
        <p-accordion [activeIndex]="activeIndex" expandIcon="pi pi-plus" collapseIcon="pi pi-minus">
            <p-accordionTab header="INFORMACIÓN RELEVANTE A LA COTIZACIÓN">
                <div class="flex align-items-start" *ngIf="dataShippingTemp.length >0">
                    <div class="pr-3">
                        <h4 class="uppercase p-0 m-0">Cliente: <span class="uppercase font-semibold cursor-pointer"
                                (click)="divInfoClient=!divInfoClient;">{{formClient.controls.razonSocial.value
                                !='NA'?formClient.controls.razonSocial.value:
                                formClient.controls.nombres.value}}</span></h4>
                    </div>
                    <div>
                        <button pButton class="p-button p-button-link p-0 m-0" icon="pi pi-file-edit"
                            label="Cambiar de cliente" (click)="newQuotation()"></button>
                    </div>
                </div>
                <div class="w-full" *ngIf="dataShippingTemp.length ==0">
                    <label>Favor relacione el número de identificación o nombre del cliente</label>
                    <div class="p-inputgroup">
                        <div class="w-full">
                            <p-autoComplete #autocomplete id="busqueda" [tabindex]="1" [suggestions]="resultsLsClients"
                                (completeMethod)="searchItem($event)" field="razonSocial" [minLength]="1"
                                (onSelect)="searchItemView($event)" [style]="{'width':'100%'}"
                                [inputStyle]="{'width':'100%'}" [(ngModel)]="fieldSearch"
                                (onKeyUp)="editFormClient=false; clearFormClient()" size="small"
                                placeholder="Ingrese la identificación o nombre del cliente" class="w-full"
                                [autofocus]="true"></p-autoComplete>
                        </div>
                    </div>
                </div>
                <div class="w-full mt-3 text-xs flex align-items-center flex-column"
                    *ngIf="resultsLsClients.length==0 && fieldSearch.length> 3">
                    <div class="w-full">
                        <hr>
                    </div>
                    Debe proceder con la
                    creación
                    del
                    cliente &nbsp;
                    <button pButton class="p-button p-button-success" label="Crear Cliente" icon="pi pi-plus"
                        (click)="divInfoClient=true; editFormClient=true"></button>
                </div>
                <div class="w-full p-2" *ngIf="selectedClient[0]?.identificacion >0 && dataShippingTemp.length==0">
                    <h4 class="uppercase cursor-pointer text-xs" (click)="divInfoClient=!divInfoClient;">
                        {{divInfoClient?'Ocultar':'Ver'}} Información del cliente</h4>
                </div>
                <!--Validación para visualizar la información del cliente-->
                <div class="w-full pt-2" *ngIf="divInfoClient">
                    <div class="cursor-pointer" *ngIf="selectedClient.length>0"
                        (click)="editFormClient=!editFormClient ">
                        <p><i class=" {{editFormClient?'pi pi-pencil':''}}"></i> {{editFormClient?'Ya puede proceder con
                            la
                            edición de la información': '¿Desea editar la información del cliente?'}}</p>
                    </div>
                    <form [formGroup]="formClient">
                        <div class="flex flex-wrap">
                            <div class="w-full md:w-6 p-2">
                                <label class="pb-2">Tipo de identificación <span
                                        class="text-xs text-red-700">*</span></label>
                                <p-select [options]="listIdentificationType" optionLabel="descripcion"
                                    (onChange)="searchClient()" placeholder="Tipo de identificación" size="small"
                                    formControlName="tipo"
                                    class="{{!editFormClient?'disabledFillFields':''}}"></p-select>
                            </div>
                            <div class="w-full md:w-6 p-2">
                                <label class="pb-2">Nro. de identificación <span class="text-xs text-red-700">*</span>
                                    <span class="text-xs" *ngIf="formClient.value.tipo?.idTipoIdentificacion ==3">
                                        Ingrese la información sin puntos y sin dígito de verificación</span></label>
                                <div class="p-inputgroup">
                                    <input pInputText type="text"
                                        class="w-full {{!editFormClient?'disabledFillFields':''}}" pSize="small"
                                        placeholder="Nro. de Identificación" formControlName="identificacion"
                                        autocomplete="off" (blur)="searchClient()">
                                    <div class="p-inputgroup-addon">
                                        <label>{{digito??''}}</label>
                                    </div>
                                </div>

                            </div>
                            <div class="w-full"><span [innerHTML]="messageClient"></span></div>
                            <div class="w-full md:w-6 p-2" *ngIf="formClient.value.tipo?.idTipoIdentificacion ==3">
                                <label class="pb-2">Razón Social <span class="text-xs text-red-700">*</span></label>
                                <input pInputText type="text" pSize="small"
                                    class="w-full uppercase {{!editFormClient?'disabledFillFields':''}}"
                                    placeholder="Razon Social" formControlName="razonSocial" autocomplete="off">
                            </div>
                            <div class="w-full md:w-6 p-2">
                                <label class="pb-2">Contacto <span class="text-xs text-red-700">*</span></label>
                                <input pInputText type="text" pSize="small"
                                    class="w-full uppercase {{!editFormClient?'disabledFillFields':''}}"
                                    placeholder="Nombres y Apellidos" formControlName="nombres" autocomplete="off">
                            </div>
                            <div class="w-full md:w-6 p-2">
                                <label class="pb-2">Correo electrónico <span
                                        class="text-xs text-red-700">*</span></label>
                                <input pInputText type="text" pSize="small"
                                    class="w-full lowercase {{!editFormClient?'disabledFillFields':''}}"
                                    placeholder="Correo Electrónico" formControlName="correo">
                            </div>
                            <div class="w-full md:w-6 p-2">
                                <label class="pb-2">Dirección</label>
                                <input pInputText type="text" class="w-full {{!editFormClient?'disabledFillFields':''}}"
                                    pSize="small" placeholder="Dirección" formControlName="direccion">
                            </div>
                            <div class="w-full md:w-6 p-2">
                                <label class="pb-2">Departamento</label>
                                <p-select [options]="listDptos" optionLabel="nombreDepartamento" size="small"
                                    placeholder="Departamento" formControlName="departamento" (onChange)="loadCities()"
                                    class="{{!editFormClient?'disabledFillFields':''}}"></p-select>
                            </div>
                            <div class="w-full md:w-6 p-2">
                                <label class="pb-2">Ciudad</label>
                                <p-select [options]="listCities" optionLabel="nombreCiudad" placeholder="Ciudad"
                                    formControlName="ciudad" size="small"
                                    class="{{!editFormClient?'disabledFillFields':''}}"></p-select>
                            </div>
                            <div class="w-full md:w-6 p-2">
                                <label class="pb-2">Nro. de teléfono</label>
                                <input pInputText type="text" class="w-full {{!editFormClient?'disabledFillFields':''}}"
                                    pSize="small" placeholder="Nro. de celular" formControlName="telefono">
                            </div>
                        </div>
                    </form>
                </div>
                <div class="w-full mt-2" *ngIf="selectedClient[0]?.clienteProcedencia.length ==0 || divInfoClient">
                    <label class="pb-2">Canal de Ingreso</label>
                    <p-select [options]="listCanalIngreso" optionLabel="descripcion" size="small"
                        class="{{selectedClient[0]?.clienteProcedencia.length> 0 ?'disabledFillFields':''}}"
                        placeholder="Seleccione el canal de ingreso" [(ngModel)]="selectedChannelIngreso"></p-select>
                </div>
                <div class="w-full text-center mt-2"
                    *ngIf="(editFormClient || selectedClient[0]?.clienteProcedencia.length ==0)">
                    <hr>
                    <button pButton icon="pi pi-check-circle" class="p-button p-button-success"
                        label="Actualizar Información" (click)="saveInfoClient()"></button>
                </div>
                <div class="w-full">
                    <hr>
                </div>
                <div class="w-full p-2" *ngIf="selectedClient[0]?.identificacion >0">
                    <h4 class="uppercase cursor-pointer text-xs" (click)="divInfoListPrices=!divInfoListPrices;">
                        {{divInfoListPrices? 'Ocultar':'Ver'}} Información de despacho y lista de precios</h4>
                </div>
                <div class="w-full flex flex-wrap" *ngIf="divInfoListPrices">
                    <div class="w-full md:w-6 mt-2 p-2" *ngIf="selectedClient.length >0">
                        <label class="pb-2">Lista de Precios</label>
                        <p-select [options]="listOfPrice" optionLabel="nombreListaPrecios" size="small"
                            class="{{this.selectedListOfPrice?.idListaPrecios > 0 ?'disabledFillFields':''}}"
                            (onChange)="getCotizacion()" placeholder="Lista de precios a aplicar"
                            [(ngModel)]="selectedListOfPrice"></p-select>
                    </div>
                    <div class="w-full md:w-6 mt-2 p-2" *ngIf="selectedClient.length >0">
                        <label class="pb-2">Canal de Venta</label>
                        <p-select [options]="lsChannelSales" [(ngModel)]="selectedChannel" optionLabel="descripcion"
                            size="small" (onChange)="eventChannel()" placeholder="Canal de venta"></p-select>
                    </div>
                    <div class="w-full  mt-2 p-2" *ngIf="selectedClient.length >0 && listPolitica.length > 1">
                        <label class="pb-2">Política Comercial</label>
                        <p-select [options]="listPolitica" [(ngModel)]="selectedPolitica" optionLabel="descripcion"
                            size="small" placeholder="Seleccione la política comercial"></p-select>
                    </div>
                    <!--*******************************Datos de Entrega*************************************-->
                    <div class="w-full mt-2 flex flex-wrap" *ngIf="selectedClient.length >0 ">
                        <div class="w-full flex flex-row">
                            <div class="p-inputgroup">
                                <p-checkbox [(ngModel)]="chkSameAddress" [binary]="true" inputId="lsChk"
                                    (onChange)="setShippingAddress()" />
                                <label for="lsChk" class="text-xs">&nbsp; Usar la misma dirección de facturación</label>
                            </div>
                            <div class="p-inputgroup">
                                <p-checkbox [(ngModel)]="chkPickUpOnSite" [binary]="true" inputId="lsChkRecogida"
                                    (onChange)="setPickupOnSite()" />
                                <label for="lsChkRecogida" class="text-xs">&nbsp; Recoge
                                    en sede</label>
                            </div>
                        </div>
                        <div class="flex flex-wrap w-full"
                            *ngIf="selectedChannel.hasShippingAddress && chkPickUpOnSite==false">
                            <div class="w-full md:w-6 mt-2 mb-3 p-2">
                                <label class="pb-2">Contacto</label>
                                <input type="text" pInputText [(ngModel)]="contactShipping" class="w-full"
                                    placeholder="Ingrese el nombre completo para la entrega"
                                    (keyup)="chkSameAddress=false;">
                            </div>
                            <div class="w-full md:w-6 mt-2 mb-3 p-2">
                                <label class="pb-2">Dirección de entrega</label>
                                <input type="text" pInputText [(ngModel)]="addressShipping" class="w-full" pSize="small"
                                    placeholder="Ingrese la dirección de despacho" (keyup)="chkSameAddress=false;">
                            </div>
                            <div class="w-full md:w-6">
                                <label class="pb-2">Departamento</label>
                                <p-select [options]="listDptos" optionLabel="nombreDepartamento" size="small"
                                    placeholder="Departamento" [(ngModel)]="stateShipping" class="w-full"
                                    (onChange)="loadCitiesShipping(); chkSameAddress=false;"></p-select>
                            </div>
                            <div class="w-full md:w-6">
                                <label class="pb-2">Ciudad</label>
                                <p-select [options]="listCitiesShipping" optionLabel="nombreCiudad" size="small"
                                    placeholder="Ciudad" [(ngModel)]="cityShipping" class="w-full"
                                    (onChange)="chkSameAddress=false;this.varsCurrentQuotation.length > 0 ? this.setShipping():'';"></p-select>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="w-full m-3" *ngIf="selectedClient.length >0">
                    <hr>
                </div>

            </p-accordionTab>
        </p-accordion>
    </div>
    <!--************************Busqueda de productos ***************************-->
    <div class="flex flex-wrap mb-6">
        <div class="w-full" *ngIf="selectedClient.length >0 && selectedChannel.idCanalVenta >0">
            <h3 class="uppercase p-0 m-0">Busqueda de productos</h3>
            <div class="p-inputgroup">
                <input type="text" pInputText [(ngModel)]="wordSearch" pSize="small"
                    placeholder="Busqueda de productos por referencia, código de barras o por descripción"
                    (keyup)="searchItemsAuto()">
                <div class="p-inputgroup-addon">
                    <div class="hidden md:flex"><button pButton icon="pi pi-search" class="p-button p-button-success"
                            label="Buscar producto" (click)="searchItems()"></button></div>
                    <div class="md:hidden flex">
                        <button pButton icon="pi pi-search" class="p-button p-button-success"
                            (click)="searchItems()"></button>
                    </div>

                </div>
            </div>
        </div>
        <div class="w-full">
            <div *ngIf="listProductsFilter.length ==0  && selectedClient.length >0 && selectedChannel.idCanalVenta >0"
                class="p-message p-message-warn">No hay productos en relación al
                filtro de
                busqueda - "{{wordSearch}}"</div>
            <div class="full mt-3" *ngIf="listProductsFilter.length >0">
                <h3 class="uppercase p-0 m-0 text-center">Listado de productos <span class="text-xs">(se encontraron
                        {{listProductsFilterCategory.length}} coincidencias)</span></h3>
                <div class="flex flex-wrap">
                    <!--****************************** Filtros de productos ***************************************-->
                    <div class="w-full md:w-2 ">
                        <h4 class="uppercase text-center">Filtros</h4>
                        <p-panelMenu [model]="listCategorizationFilter" styleClass="w-full  text-xs sticky top-0">
                            <ng-template #item let-item>
                                <div
                                    class="flex align-items-center cursor-pointer text-surface-700  px-3 py-2 {{idSelectedCategory==item.id ? 'bg-gray-50':''}}">
                                    <span [class]="'pi pi-check'"></span>
                                    <span class="ml-2 text-xs">{{ item.label }}</span>
                                    <i *ngIf="item.items.length>0" class="pi pi-angle-down text-primary ml-auto"></i>
                                </div>
                            </ng-template>
                            <ng-template #headercontent let-item>
                                <div
                                    class="flex align-items-center cursor-pointer text-surface-700 px-3 py-2 {{idSelectedCategory==item.id ? 'bg-gray-50':''}}">
                                    <span [class]="item.icon"></span>
                                    <span class="ml-2 text-xs">{{ item.label }}</span>
                                    <i *ngIf="item.items.length>0" class="pi pi-angle-down text-primary ml-auto"></i>
                                </div>
                            </ng-template>
                        </p-panelMenu>
                    </div>
                    <!--****************************** Listado de productos ***************************************-->
                    <div class=" w-full md:w-10 flex flex-wrap h-full">
                        <div class="w-full text-left mt-2 text-xs">
                            <span *ngFor="let item of categoriaSelected; let first=index">{{first>0?'/':''}}
                                {{item.nameCategory}}</span>
                        </div>
                        <div class="w-full gap-2 {{last?'mb-5':''}}"
                            *ngFor="let item of listProductsFilterCategory; let $index=index; let last=last">
                            <div class="flex flex-column sm:flex-row sm:align-items-center p-4 gap-3"
                                [ngClass]="{ 'border-top-1 surface-border': !$index }">
                                <div class="md:w-10rem relative">
                                    <img class="block xl:block mx-auto border-round w-full"
                                        [src]="item.productoImagenes.length > 0 ? urlImages + item.productoImagenes[0].ubicacion:'assets/img/noImg.png'"
                                        [alt]="item.productoImagenes.length > 0 ? item.productoImagenes[0].etiqueta:item.descripcionCorta" />
                                    <!-- <p-tag [value]="item.inventoryStatus" [severity]="'success'" class="absolute"
                                        [style.left.px]="4" [style.top.px]="4" /> -->
                                </div>
                                <div
                                    class="flex flex-column md:flex-row justify-content-between md:align-items-center flex-1 gap-4">
                                    <div
                                        class="flex flex-row md:flex-column justify-content-between align-items-start gap-2">
                                        <div>
                                            <span class="font-medium text-secondary text-sm">{{
                                                item.categorizacion[0]?.nameCategory }} / {{
                                                item.categorizacion[1]?.nameCategory }} </span><br>
                                            <span class="font-medium text-secondary text-sm">SKU:
                                                {{item.codBarras}} </span>
                                            <div class="text-lg font-medium  mt-2">{{ item.descripcionCorta }}
                                            </div>
                                            <span class="font-medium text-secondary text-sm">{{ item.marca }}</span><br>
                                            <span class="font-medium text-secondary text-sm">Unidad de presentación: {{
                                                item.unidadPresentacion }}</span>

                                        </div>
                                        <!-- <div class="surface-100 p-1" style="border-radius: 30px">
                                            <div class="surface-0 flex align-items-center gap-2 justify-content-center py-1 px-2"
                                                style="border-radius: 30px; box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.04), 0px 1px 2px 0px rgba(0, 0, 0, 0.06)">
                                                <span class="font-medium text-sm">{{ item.rating }}</span>
                                                <i class="pi pi-star-fill text-yellow-500"></i>
                                            </div>
                                        </div> -->
                                    </div>
                                    <div class="flex flex-column md:align-items-end gap-5">
                                        <span class="text-xl font-semibold">
                                            <span class="text-xs block"
                                                *ngIf="item.detalleListaPrecios[0].precio > item.detalleListaPrecios[0].precioPromocion">
                                                <del> {{
                                                    item.detalleListaPrecios[0].precio | currency }}</del></span>
                                            {{
                                            item.detalleListaPrecios[0].precioPromocion | currency }}</span>
                                        <div class="flex flex-row-reverse md:flex-row gap-2">
                                            <!-- <p-button icon="pi pi-heart" [outlined]="true" /> -->
                                            <p-button icon="pi pi-shopping-cart" [loading]="item.loading"
                                                class="flex-auto md:flex-initial white-space-nowrap" label="Adicionar"
                                                (click)="setCotizacion(item)"
                                                [disabled]="item.inventoryStatus === 'OUTOFSTOCK'" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div [innerHTML]="item.message"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="bg-gray-50 text-center w-full p-3 fixed bottom-0" *ngIf="cotizacionCurrent?.idCotizacion>0">
        <i class="pi pi-shop"></i>&nbsp;Tienes una cotización en curso nro. ({{cotizacionCurrent.idCotizacion}}) <span
            class="text-xs">(con
            {{cotizacionCurrent.detalleCotizacionInicials.length}} líneas). <a class="p-button p-button-link p-0 m-0"
                (click)="toSeeDetail()">Ver detalle</a> </span>
    </div>
</div>
<!--Información de sistema alterno-->
<p-dialog header="Cargar información de sistema alterno" [(visible)]="displayInfoTercero" [modal]="true">
    <div class="p-message p-message-info p-3">Se ha encontrado información en el sistema integrado, ¿Desea visualizar la
        información? <br><button pButton label="SI" icon="pi pi-check-circle" (click)="fillFormClientExternSystem()"
            class="p-button p-button-success"></button> | <button pButton label="NO" icon="pi pi-times-circle"
            class="p-button p-button-danger" (click)="displayInfoTercero=false;"></button></div>
</p-dialog>

<p-toast></p-toast>